import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ProductSlider, CollectionSlider } from '../../shared/data/slider';
import { Product } from '../../shared/classes/product';
import { ProductService } from '../../shared/services/product.service';

@Component({
  selector: 'app-watch',
  templateUrl: './watch.component.html',
  styleUrls: ['./watch.component.scss']
})
export class WatchComponent implements OnInit, OnDestroy {

  public themeLogo: string = 'assets/images/icon/logo.png'; // Change Logo
  
  public products: Product[] = [];
  public productCollections: any[] = [];

  public ProductSliderConfig: any = ProductSlider;
  public CollectionSliderConfig: any = CollectionSlider;
  public active;

  constructor(private _sanitizer:DomSanitizer,
    public productService: ProductService) {
    this.productService.getProducts.subscribe(response => {
      this.products = response.filter(item => item.type == 'watch');
      // Get Product Collection
      this.products.filter((item) => {
        item.collection.filter((collection) => {
          const index = this.productCollections.indexOf(collection);
          if (index === -1) this.productCollections.push(collection);
        })
      })
    });
  }

  public sliders = [{
    title: 'We Help IT Companies Scale Engineering .    ',
    subTitle: 'We focus on strategic planning and utilizing technology to satisfy business needs to create efficient processes.    ',
    image: 'assets/images/slider/1.jpg'
  }, {
    title: 'Professional Custom Software Development Services    ',
    subTitle: 'We focus on strategic planning and utilizing technology to satisfy business needs to create efficient processes.    ',
    image: 'assets/images/slider/2.jpg'
  }];

  // Logo
  public logos = [{
    image: 'assets/images/logos/1.png',
  }, {
    image: 'assets/images/logos/2.png',
  }, {
    image: 'assets/images/logos/3.png',
  }, {
    image: 'assets/images/logos/4.png',
  }, {
    image: 'assets/images/logos/5.png',
  }, {
    image: 'assets/images/logos/6.png',
  }, {
    image: 'assets/images/logos/7.png',
  }, {
    image: 'assets/images/logos/8.png',
  }];

  // Collection
  public categories = [{
    image: 'assets/images/categories/hover-app-img01.webp',
    title: 'Only The Best Tech',
    text:  this._sanitizer.bypassSecurityTrustHtml('<p>  we use only the latest, best, & most suitable technologies in our IT services & solutions, driving success.</p>'),
  }, {
    image: 'assets/images/categories/hover-app-img02.webp',
    title: 'Innovation Drive',
    text:  this._sanitizer.bypassSecurityTrustHtml('<p>   Innovation is the name of the game, in the age of technology. Our solutions are focused on helping businesses innovate inside and outside.</p>'),
  }, {
    image: 'assets/images/categories/hover-app-img03.webp',
    title: 'Expert Developers',
    text:  this._sanitizer.bypassSecurityTrustHtml('<p> Our team of developers & designers are creative, experienced, professionals, & always explore new possibilities to disrupt the market.</p>'),
  }, {
    image: 'assets/images/categories/class.png',
    title: 'Tailored Solution',
    text:  this._sanitizer.bypassSecurityTrustHtml('<p>Every business is unique and they deserve solutions that are tailored to their needs & preferences. That’s what we deliver.</p>'),
  }]

  // collection
  public collections = [{
    image: 'assets/images/tch10.png/services/elevate-your-travel-experience-with-our-hotel-booking-system/',
    title: 'minimum 10% off',
    text:  this._sanitizer.bypassSecurityTrustHtml('<p>Only The Best Tech  we use only the latest, best, & most suitable technologies in our IT services & solutions, driving success.</p>'),
  }, {
    image: 'assets/images/tch10.png/services/wp-content/uploads/2024/03/stock-photo-coding-software-developer-work-augmented-reality-dashboard-computer-icons-scrum.jpg',
  }, {
    image: 'assets/images/tch10.png/services/elevate-your-travel-experience-with-our-hotel-booking-system/',
    title: 'minimum 10% off',
    text:  this._sanitizer.bypassSecurityTrustHtml('<p>Only The Best Tech  we use only the latest, best, & most suitable technologies in our IT services & solutions, driving success.</p>'),
  }]

   // Blog
  public blogs = [{
    image: 'assets/images/tch10.png/services/wp-content/uploads/2024/03/stock-photo-coding-software-developer-work-augmented-reality-dashboard-computer-icons-scrum.jpg',
    link:'assets/images/tch10.png/services/elevate-your-online-presence-with-professional-web-development-services/',
    date: 'March 30, 2024',
    title: 'Unleashing Creativity with Android Development: Building Innovative Mobile Experiences,',
    by: 'John Dio'
  }, {
    image: 'assets/images/tch10.png/services/wp-content/uploads/2024/03/stock-photo-website-designer-working-with-the-new-computer-interface-as-desi.jpg',

    link:'assets/images/tch10.png/services/elevate-your-online-presence-with-professional-web-development-services/',

    date: 'March 30, 2024',
    title: 'Elevate Your Travel Experience with Our Hotel Booking System    ',
    by: 'John Dio'
  }, {
    image: 'assets/images/tch10.png/services/wp-content/uploads/2024/03/stock-photo-website-designer-working-with-the-new-computer-interface-as-desi.jpg',
    date: 'March 30, 2024',
    link:'assets/images/tch10.png/services/elevate-your-online-presence-with-professional-web-development-services/',
   
    title: 'The Role of Artificial Intelligence in Modern Business Solutions    ',
    by: 'John Dio'
  }, {
    image: 'assets/images/tch10.png/services/wp-content/uploads/2024/03/stock-photo-programmer-working-software-development-coding-technologies-website-design-technology-concept.jpg',
    link:'assets/images/tch10.png/services/elevate-your-online-presence-with-professional-web-development-services/',
    date: 'March 30, 2024',
    title: 'Elevate Your Online Presence with Professional Web Development Services',
    by: 'John Dio'
  }]

  ngOnInit(): void {
    // Change color for this layout
    document.documentElement.style.setProperty('--theme-deafult', '#e4604a');
  }

  ngOnDestroy(): void {
    // Remove Color
    document.documentElement.style.removeProperty('--theme-deafult');
  }

  // Product Tab collection
  getCollectionProducts(collection) {
    return this.products.filter((item) => {
      if (item.collection.find(i => i === collection)) {
        return item
      }
    })
  }

}
